export default `
  .dashboard-panel {
    & + & {
      margin-top: 60px;
    }
  }
`;
